import Vue from 'vue'
import store from './store'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/app.scss';
import '@/assets/css/margin.scss';
import '@/assets/css/padding.scss';
import '@/assets/css/display.scss';
import '@/assets/css/font.scss';
import '@/assets/css/backgroundColor.scss';
import '@/assets/css/opacity.scss';
import '@/assets/css/position.scss';
import '@/assets/css/border-radius.scss';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import '@/assets/js/splitHtml'
import * as echarts from "echarts" //引入echarts
import { isCtrlPress } from '@/utils/keyboard';
import {imgPath} from "@/utils/commonData";
// import './mock'
import moment from "moment";
import { SSE } from "sse.js";

Vue.prototype.$SSE = SSE;

Vue.prototype.$EventBus = new Vue();

Vue.prototype.$echarts = echarts //注册组件
// 图片配置前缀
// Vue.prototype.$imgPath = 'http://192.168.30.170:9000/public.luhe.cqvip.com/'
Vue.prototype.$imgPath = imgPath
const isDev =  process.env.NODE_ENV === "development"
const servePath = isDev ? "http://192.168.98.105:8001" : "https://accountv3.cqvip.com"
// 登录跳转路径
Vue.prototype.$loginBack = isDev ? servePath + '?serve='+location.origin+'&appCode=104' : servePath + "?serve=https://luhe.cqvip.com&appCode=104"
// 注册跳转路径
Vue.prototype.$registBack = isDev ? servePath + '/register?serve='+location.origin+'&appCode=104' : servePath + "/register?serve=https://luhe.cqvip.com&appCode=104"
// 全局过滤器的定义
Vue.filter("global_filter", function (value, type = "YYYY-MM-DD HH:mm:ss") {
  return moment(value).format(type);
})

Vue.filter("global_hiddenPhone", function (value) {
  return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
})

var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到

Vue.use(ElementUI, VueAwesomeSwiper)
//字体图标
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if(to.name === from.name) {
    next()
    return;
  }
  // 在每次路由跳转的时候进行判断
  if (to.fullPath.indexOf("word2") < 0) {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?9c121517d1c6c6a60d4c5e41353de2fe";
    hm.id = "baidu";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  }

  if (isCtrlPress()) {
    // 若是 ctrl 按键被按下，则以新窗口打开目标页面
    let routeUrl = router.resolve({
      path: to.fullPath,
    });
    window.open(routeUrl.href, "_blank");
    return next(false)
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
